import Vue from 'vue'
import VueRouter from 'vue-router'

import HostRoute from './host.route'
import AuthRoute from './auth.route'
import DashboardRoute from './dashboard.route'
import StockPickRoute from './stockpick.route'
import EducationRoute from './education.route'
import AnalysisRoute from './analysis.route'
import ChartRoute from './chart.route'
import QnaRoute from './qna.route'
import StockRoute from './stock.route'
import NotificationRoute from './notification.route'
import ProfileRoute from './profile.route'
import LandingpageRoute from './landingpage.route'
import PromotionRoute from './promotion.route'
import ExternalRoute from './external.route'
import ErrorRoute from './error.route'
import { isChartHost } from './chart-hosts'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...HostRoute,
    ...AuthRoute,
    ...DashboardRoute,
    ...StockPickRoute,
    ...EducationRoute,
    ...AnalysisRoute,
    ...ChartRoute,
    ...QnaRoute,
    ...StockRoute,
    ...NotificationRoute,
    ...ProfileRoute,
    ...LandingpageRoute,
    ...PromotionRoute,
    ...ErrorRoute,
    ...ExternalRoute,
  ],
})

const redirectToDashboardParams = [
  'login',
  'signup',
  'signupverify',
  'home',
  'index',
  'forget',
]

router.beforeEach((to, from, next) => {
  if (isChartHost() && to.path !== '/') {
    next({ path: '/', query: to.query, replace: true })
    return
  }

  localStorage.routeBefore = from.name !== '' ? from.name : ''

  const storageUser =
    localStorage.vuex !== undefined ? JSON.parse(localStorage.vuex) : {}

  // const currentVersion = process.env.VUE_APP_VERSION
  // if (currentVersion !== store.state.appVersion) {
  //   store.dispatch('setAppVersion', currentVersion)
  // }

  if (to.meta.requiresAuth) {
    if (storageUser.user && storageUser.user.token) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else {
    if (
      redirectToDashboardParams.includes(to.name) &&
      storageUser.user &&
      storageUser.user.token
    ) {
      next('dashboard')
    } else {
      if (to.name !== null || to.path.includes === '/event') {
        next()
      } else {
        next({ name: 'notfound' })
      }
    }
  }
})

export default router
